/**
 * File initSplideSliders.js
 *
 * Initializes the various splide slider components
 * 
 */

module.exports = initSpliders = ( carousels ) => {
    carousels = carousels || [];
    if( carousels.length > 0 ) {
        carousels.forEach( carousel => {
            // let sliderType = carousel.getAttribute('data-carousel') || 'standard' || 'product';
            let sliderType = carousel.dataset.carousel;
            //check for type of carousel
            const options = {
                standard : {
                    type   : 'slide',
                    perPage: 3,
                    arrows: false,
                    pagination: true,
                    drag: true,
                    keyboard: true,
                    gap: '10px',
                    breakpoints: {
                        768: {
                            perPage: 2,
                        },
                        640: {
                            perPage: 1,
                        },
                    }
                },
                product : {
                    type   : 'slide',
                    arrows: true,
                    pagination: false,
                    drag: true,
                    keyboard: true,
                    fixedWidth : '200px',
                    gap: '20px',
                    padding: {
                        left: '0px',
                        right: '5%',
                    },
                    breakpoints: {
                        767: {
                            padding: {
                                left: '15px',
                                right: '15px',
                            },
                        },
                    }
                }
            }
            var Splider = carousel;
            var SpliderDefaults = options[sliderType];
        
            var splide = new Splide( Splider, SpliderDefaults )

            splide.mount();
        } )
    }
    return false;
 }